import React, { FC } from 'react';

interface TablePitchStatProps {
  value: string;
}

export const TablePitchStat: FC<TablePitchStatProps> = ({ value }) => {
  return <div className="font-semibold">{value}</div>;
};
